import { title } from "process";

const initialColumns = [
  { title: 'Initiative Number', dataIndex: 'initiativeNumber', key: 'initiativeNumber' },
  { title: 'Initiative Name', dataIndex: 'initiativeName', key: 'initiativeName' },
  { title: 'Stage Simplified', dataIndex: 'Stage Simplified', key: 'stage' },
  { title: 'Stage ', dataIndex: 'Stage', key: 'stageSimplified' },
  { title: 'Weekly Status', dataIndex: 'weeklyStatus', key: 'weeklyStatus' },
  { title: 'Initiative Owner', dataIndex: 'initiativeOwnerInfo', key: 'initiativeOwnerInfo' },
  {
    title: 'Accountable Workstream',
    dataIndex: 'workstreamSponsorWorkstream',
    key: 'workstreamSponsorWorkstream',
  },
  {
    title: 'Cross-functional support needed',
    dataIndex: 'crossFunctionalSupportWorkstreamInfo',
    key: 'crossFunctionalSupportWorkstreamInfo',
  },
  {
    title: 'Sector',
    dataIndex: 'sectorInfo',
    key: 'sectorInfo',
  },
  {
    title: 'Subsector',
    dataIndex: 'subsectorInfo',
    key: 'subsectorInfo',
  },
  {
    title: 'Segment',
    dataIndex: 'initiativeCategory',
    key: 'initiativeCategory',
  },
  {
    title: 'Subsegment',
    dataIndex: 'segment',
    key: 'segment',
  },
  {
    title: 'Strategy Belongs To',
    dataIndex: 'strategyInfo',
    key: 'strategyInfo',
  },
  {
    title: 'Initiative Owner (back-up)',
    dataIndex: 'initiativeOwnerBackupInfo',
    key: 'initiativeOwnerBackupInfo',
  },
  {
    title: 'Access',
    dataIndex: 'AllowOnlyTo',
    key: 'AllowOnlyTo',
  },
  {
    title: 'Has financial impacts?',
    dataIndex: 'hasFinancialImpact',
    key: 'hasFinancialImpact',
  },
  {
    title: 'Is Customer Related?',
    dataIndex: 'forSpecificCustomer',
    key: 'forSpecificCustomer'
  },
  {
    title: 'Segmental PBT',
    dataIndex: 'segmentalPBT',
    key: 'segmentalPBT'
  },
  {
    title: 'Priority',
    dataIndex: 'priority',
    key: 'priority'
  },
  {
    title: 'Select for TO meeting discussion',
    dataIndex: 'selectedForToMeetingDescusion',
    key: 'selectedForToMeetingDescusion',
  },
  {
    title: 'Workstream Lead',
    dataIndex: 'workstreamLeadInfo',
    key: 'workstreamLeadInfo',
  },
  { title: 'Workstream Sponsor', dataIndex: 'workstreamSponsorInfo', key: 'workstreamSponsorInfo' },
  {
    title: 'Subworkstream',
    dataIndex: 'workstreamLeadSubworkstream',
    key: 'workstreamLeadSubworkstream',
  },
  {
    title: 'Net Recurring Benefit',
    dataIndex: 'impact',
    key: 'netRecurringBenefit',
  },
  { title: 'One Time Benefit', dataIndex: 'impact', key: 'oneTimeBenefit' },
  { title: 'One Time Implementation Cost', dataIndex: 'KPI', key: 'oneTimeImplementationCost' },
  {
    title: 'L3 Plan Date',
    dataIndex: 'timeline',
    key: 'L3 planned date',
  },
  {
    title: 'L4 Plan Date',
    dataIndex: 'timeline',
    key: 'L4 planned date',
  },
  {
    title: 'Planning Summary',
    dataIndex: 'planningSummary',
    key: 'Planning summary',
  },
  {
    title: 'Planning summary simplified',
    dataIndex: 'Planning summary simplified',
    key: 'Planning summary simplified',
  },
  {
    title: 'Workstream Lead pending approval?',
    key: 'Workstream lead pending approval',
    dataIndex: 'workstreamLeadPendingApproval', // Using a consistent key
  },
  {
    title: 'Workstream Sponsor pending approval?',
    dataIndex: 'workstreamSponsorPendingApproval',
    key: 'Workstream sponsor pending approval',
  },
  {
    title: 'Finance lead pending approval?',
    key: 'TO finance pending approval',
    dataIndex: 'financeLeadPendingApproval',
  },
  {
    title: 'Strategy Analyst pending approval?',
    key: 'Strategy analyst pending approval',
    dataIndex: 'strategyAnalystPendingApproval',
  },
  {
    title: 'Net recurring benefits range (latest estimate, annualized)',
    dataIndex: 'impact',
    key: 'Net recurring benefit range',
  },
  {
    title: 'Future implementation costs range',
    key: 'Future implementation costs range',
    dataIndex: 'implementationCostCategory',
  },
  {
    title: 'Pipeline weekly variance (L0+)',
    key: 'Pipeline weekly variance (L0+)',
    dataIndex: 'netRecurringBenefitChangeCategory',
  },
  {
    title: 'Pipeline weekly variance (L1+)',
    key: 'Pipeline weekly variance (L1+)',
    dataIndex: 'netRecurringBenefitChangeCategoryL1',
  },
  {
    title: 'Pipeline weekly variance (L2+)',
    key: 'Pipeline weekly variance (L2+)',
    dataIndex: 'netRecurringBenefitChangeCategoryL2',
  },
  {
    title: 'Pipeline weekly variance (L3+)',
    key: 'Pipeline weekly variance (L3+)',
    dataIndex: 'netRecurringBenefitChangeCategoryL3',
  },
  {
    title: 'Pipeline weekly variance (L4+)',
    key: 'Pipeline weekly variance (L4+)',
    dataIndex: 'netRecurringBenefitChangeCategoryL4',
  },
  {
    title: 'actualKpiUpdateCheck',
    key: 'Actual KPI update check (for last completed and previous period)',
    dataIndex: 'actualKpiUpdateCheck',
  },
  {
    title: 'actualImpactUpdateCheck',
    key: 'Actual impact update check (for last completed and previous period)',
    dataIndex: 'actualImpactUpdateCheck',
  },
  {
    title: '(FY23-24) Actual impact update check',
    key: '(FY23-24) Actual impact update check',
    dataIndex: 'fy2324ActualImpactUpdateCheck',
  },
  {
    title: '(FY24-25) Actual impact update check',
    key: '(FY24-25) Actual impact update check',
    dataIndex: 'fy2425ActualImpactUpdateCheck',
  },
  {
    title: 'L3 date compliance check (forecast vs planned date)',
    key: 'L3 date compliance check (forecast vs planned date)',
    dataIndex: 'l3DateComplianceCheck',
  },
  {
    title: 'L4 date compliance check (forecast vs planned date)',
    key: 'L4 date compliance check (forecast vs planned date)',
    dataIndex: 'l4DateComplianceCheck',
  },
  {
    title: 'L1 Original Planned Date',
    dataIndex: 'L1 Original Planned Date',
    key: 'L1 Original Planned Date'
  },
  {
    title: 'L2 Original Planned Date',
    dataIndex: 'L2 Original Planned Date',
    key: 'L2 Original Planned Date'
  },
  {
    title: 'L3 Original Planned Date',
    dataIndex: 'L3 Original Planned Date',
    key: 'L3 Original Planned Date'
  },
  {
    title: 'L4 Original Planned Date',
    dataIndex: 'L4 Original Planned Date',
    key: 'L4 Original Planned Date'
  },
  {
    title: 'L5 Original Planned Date',
    dataIndex: 'L5 Original Planned Date',
    key: 'L5 Original Planned Date'
  },
  {
    title: 'L1 Planned Date',
    dataIndex: 'L1 planned date',
    key: 'L1 planned date'
  },
  {
    title: 'L2 Planned Date',
    dataIndex: 'l2PlannedDate',
    key: 'L2 planned date',
  },
  {
    title: 'L5 Planned Date',
    dataIndex: 'l5PlannedDate',
    key: 'L5 planned date',
  },
  {
    title: 'L0 Actual Date',
    dataIndex: 'l0ActualDate',
    key: 'L0 actual date',
  },
  {
    title: 'L1 Actual Date',
    dataIndex: 'l1ActualDate',
    key: 'L1 actual date',
  },
  {
    title: 'L2 Actual Date',
    dataIndex: 'l2ActualDate',
    key: 'L2 actual date',
  },
  {
    title: 'L3 Actual Date',
    dataIndex: 'l3ActualDate',
    key: 'L3 actual date',
  },
  {
    title: 'L4 Actual Date',
    dataIndex: 'l4ActualDate',
    key: 'L4 actual date',
  },
  {
    title: 'L5 Actual Date',
    dataIndex: 'l5ActualDate',
    key: 'L5 actual date',
  },
  {
    title: 'Sub. For L1 Approve Date',
    dataIndex: 'subForL1ApprovDate',
    key: 'Sub . for L1 approv . date',
  },
  {
    title: 'Sub. For L2 Approve Date',
    dataIndex: 'subForL2ApprovDate',
    key: 'Sub . for L2 approv . date',
  },
  {
    title: 'Sub. For L3 Approve Date',
    dataIndex: 'subForL3ApprovDate',
    key: 'Sub . for L3 approv . date',
  },
  {
    title: 'Sub. For L4 Approve Date',
    dataIndex: 'subForL4ApprovDate',
    key: 'Sub . for L4 approv . date',
  },
  {
    title: 'Sub . for L5 approv . date',
    dataIndex: 'subForL5ApprovDate',
    key: 'Sub . for L5 approv . date',
  },
  {
    title: 'Number of Attachment',
    dataIndex: 'Number of Attachment',
    key: 'Number of attachments',
  },
  {
    title: 'Has qualitative KPI?',
    dataIndex: 'Has qualitative KPI?',
    key: 'Has qualitative KPI?',
  },
  {
    title: 'initiativeNumber - initiativeName',
    dataIndex: 'initiativeNumber - initiativeName',
    key: 'initiativeNumber - initiativeName',
  },
  {
    title: 'Cancellation date',
    dataIndex: 'Cancellation date',
    key: 'Cancellation date'
  },
  {
    title: 'Description',
    dataIndex: 'Description',
    key: 'Description'
  }
];
export default initialColumns;
